// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mKe1","tabsBox":"styles_tabsBox__3_S34","createButton":"styles_createButton__p7-f0"};